import { render, staticRenderFns } from "./page-pop-card.vue?vue&type=template&id=25ab51d0&scoped=true"
import script from "./page-pop-card.vue?vue&type=script&lang=js"
export * from "./page-pop-card.vue?vue&type=script&lang=js"
import style0 from "./page-pop-card.styl?vue&type=style&index=0&id=25ab51d0&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ab51d0",
  null
  
)

export default component.exports